import {UseCase} from '@s-ui/domain'
/**
 * @implements UseCase
 */
export default class GetUserTakeoutLinkUseCase extends UseCase {
  constructor({service, log}) {
    super()

    this._service = service
    this._log = log
  }

  /**
   * @return {Promise<Object, Error>}
   */

  execute({requestId, filename, useTranscendAPI = false} = {}) {
    this._log('Getting user takeout link')
    return this._service
      .execute({requestId, filename, useTranscendAPI})
      .then(valueObject => {
        if (useTranscendAPI) {
          return {blob: valueObject.getBlob()}
        }
        return valueObject.toJSON()
      })
      .catch(e => Promise.reject(Error(`GetUserTakeoutLinkUseCase[execute] has had an error: ${e}`)))
  }
}
